webpackJsonp([81],{

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1268);


/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(179);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(789);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1267]);


// WEBPACK FOOTER //
// app/datetime.de-63cbea6ba463076b7bff.js